export default function ListTogetherIcon() {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 164.02 164.02"
    >
      <title>List Together Icon</title>
      <g id="Layer_1" data-name="Layer 1">
        <rect x="4" y="3.92" width="154.48" height="154.48" fill="#d1d5db" />
        <g opacity="0.56">
          <rect x="2.22" y="34.18" width="158.3" height="4" fill="#9ca3af" />
        </g>
        <g opacity="0.56">
          <rect x="2.22" y="57.16" width="158.3" height="4" fill="#9ca3af" />
        </g>
        <g opacity="0.56">
          <rect x="2.22" y="82.18" width="158.3" height="4" fill="#9ca3af" />
        </g>
        <g opacity="0.56">
          <rect x="2.22" y="107.2" width="158.3" height="4" fill="#9ca3af" />
        </g>
        <g opacity="0.56">
          <rect x="2.22" y="132.22" width="158.3" height="4" fill="#9ca3af" />
        </g>
        <rect x="30.57" y="2.48" width="6.63" height="159.83" fill="#9ca3af" />
        <path
          d="M168,181.57H31a13.52,13.52,0,0,1-13.5-13.5v-137A13.51,13.51,0,0,1,31,17.55H168a13.51,13.51,0,0,1,13.5,13.5v137A13.51,13.51,0,0,1,168,181.57ZM31,24.55a6.51,6.51,0,0,0-6.5,6.5v137a6.51,6.51,0,0,0,6.5,6.5H168a6.51,6.51,0,0,0,6.5-6.5v-137a6.5,6.5,0,0,0-6.5-6.5Z"
          transform="translate(-17.49 -17.55)"
          fill="#1e3a8a"
        />
      </g>
      <g id="Layer_2" data-name="Layer 2">
        <polyline
          points="61.05 40.62 49.27 54.05 44.15 48.21"
          fill="none"
          stroke="#1e3a8a"
          strokeMiterlimit="10"
          strokeWidth="4"
        />
        <polyline
          points="61.05 64.95 49.27 78.39 44.15 72.55"
          fill="none"
          stroke="#1e3a8a"
          strokeMiterlimit="10"
          strokeWidth="4"
        />
        <polyline
          points="61.05 89.29 49.27 102.72 44.15 96.88"
          fill="none"
          stroke="#1e3a8a"
          strokeMiterlimit="10"
          strokeWidth="4"
        />
        <polyline
          points="61.05 113.62 49.27 127.06 44.15 121.22"
          fill="none"
          stroke="#1e3a8a"
          strokeMiterlimit="10"
          strokeWidth="4"
        />
      </g>
    </svg>
  );
}
